import React from 'react';
import {Text} from '@tempo/core';

interface HighlightedTextProps {
	query: string;
	children?: string;
}

const HighlightedText = ({query, children}: HighlightedTextProps) => {
	const sanitizedQuery = query.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
	const regex = new RegExp(`(${sanitizedQuery})`, 'ig');
	if (typeof children !== 'string' || !children.match(regex)) {
		return <>{children}</>;
	}

	return (
		<>
			{children.split(regex).map((part, index) => {
				if (part.match(regex)) {
					return (
						<Text
							key={`highlighted-part-${index}`}
							as="span"
							color="text.accent.primary.default"
							fontWeight="bold"
						>
							{part}
						</Text>
					);
				}
				return part;
			})}
		</>
	);
};

export default HighlightedText;
